import { get, apiPrefix } from './common';
import { webApiResponseHandler } from './api';
const getPCardMasters = () => get(`${apiPrefix}/PCardMasters?active=true`).then(webApiResponseHandler);
export { getPCardMasters };
